import $ from 'jquery';
import {HTTP_STATUS_UNAUTHORIZED} from '../smartpak/httpstatus.js';

function onSuccess(callback) {
    return function(response) {
        if ($.isFunction(callback)) {
            callback(response);
        }
    };
}

function onFail(callback, url, context) {
    return function(response) {
        if ($.isFunction(callback)) {
            callback(response);
        } else {
            context.alertFailure(url, response);
        }
    };
}

function slice(args) {
    return [].slice.call(args);
}

const client = {
    get: function(url, success, fail) {
        return $.ajax({
            url: url,
            type: 'GET',
            contentType: 'application/json',
            cache: true
        })
            .done(onSuccess(success))
            .fail(onFail(fail, url, this));
    },
    post: function(url, data, success, fail) {
        return $.ajax({
            url: url,
            type: 'POST',
            data: data,
            contentType: 'application/json'
        })
            .done(onSuccess(success))
            .fail(onFail(fail, url, this));
    },
    put: function(url, data, success, fail) {
        return $.ajax({
            url: url,
            type: 'PUT',
            data: data,
            contentType: 'application/json'
        })
            .done(onSuccess(success))
            .fail(onFail(fail, url, this));
    },
    loadDataWithoutCache: function(url, success, fail) {
        return $.ajax({
            url: url,
            dataType: 'html',
            cache: false
        })
            .done(onSuccess(success))
            .fail(onFail(fail, url, this));
    },
    alertFailure: function(url, response) {
        if (window.console && window.console.log && response.statusText !== 'abort') {
            window.console.log('API failure:' + url, response);
        }

        if (response.status && response.status === HTTP_STATUS_UNAUTHORIZED) {
            this.redirectToLogin(response);
        }
    },
    redirectToLogin: function() {
        window.location.href = '/account/login?returnUrl=' + window.location.href;
    },
    createConcatRequestMethod: function(type, url) {
        return function() {
            var args = slice(arguments);

            return client[type].apply(client, [url + args.shift()].concat(args));
        };
    },
    createRequestMethod: function(type, url) {
        return function() {
            var args = slice(arguments);
            return client[type].apply(client, [url].concat(args));
        };
    }
};

export default client;
